module.exports = __webpack_public_path__ + "img/binance-chain-logo.d2b6c0fb.svg";